// Module
var code = "<div> <canvas id=\"image-canvas\" style=\"height:300px;width:600px\"></canvas> <video ng-hide=\"true\" id=\"video-player\" ng-src=\"{{videoLinkTrust}}\" type=\"video/webm\"> </video> <p>{{ 'edit.video.transcodeMessage' | translate }}</p> </div>";
// Exports
module.exports = code;